import styled from 'styled-components'
import { Color } from 'root-constants'

export const StyledAnswerButtonLight = {
  Content: styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 100%;
    min-height: 56px;
    cursor: pointer;
    background: ${Color.WHITE};
    border-radius: 30px;
    color: ${Color.DARK};
    padding: 0 20px;
    font-weight: 500;
    font-size: 17px;
    line-height: 24px;

    input:checked + & {
      background: ${Color.GRADIENT};
      color: #fff;
    }
  `,
}
